module.exports = __webpack_public_path__ + "static/media/08.b0e61dbd.svg";